export class AuthenticationError extends Error {
    name = 'authenticationError'
}

export class FileTypeError extends Error {
    name = 'fileTypeError'
}

export class ParameterError extends Error {
    name = 'parameterError'
}